import axiosInstance from "../../api/auth/axiosInstance";
export const FetchDoctors = {
  fetchDoctors: async  () => {
  try {
    const response = await axiosInstance.get(`/search/main-page-doctors`, {
      headers: { authType: "PreLogin" },
    });
    return response;
  } catch (error) {
    
    throw new Error(error);
  }
  },
};

export default FetchDoctors;